/* eslint-disable */

import { Size } from "../../logic/enums.ts";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropHeading from "../raindrop-heading/raindrop-heading.tsx";

import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";

const PoliticsScale = ({ proportion = 0.5 }) => {
  return (
    <div className="w-full">
      <div className="flex items-center w-full  rounded-full bg-white bg-gradient-to-r from-blue-600 via-purple-600 to-red-600 border border-opacity-30">
        <div
          style={{
            width: `${proportion * 100}%`,
          }}
        />
        <div className="h-4 w-4 rounded-full bg-white m-2" />
      </div>
    </div>
  );
};

const PoliticalSlider = ({
  isPolitical = true,
  title = "Social values",
  proportion = 0.2,
  leftDescription = "Generally supports environmental and LGBTQ+ friendly policies.",
  rightDescription = "Generally supports more traditional social values.",
}) => {
  if (!isPolitical) {
    return null;
  }
  return (
    <div className="flex w-full">
      <RaindropCard>
        <div className="flex flex-col gap-2 w-full">
          <PoliticsScale proportion={proportion} />
          <RaindropHeading title={title} />
          <div className="flex flex-col gap-2">
            <div className="flex flex-row  items-center gap-2">
              <div className="w-6 h-6 aspect-square bg-blue-600 rounded-lg" />
              <div className="text-xs w-full text-left text-color-text-tertiary">
                {leftDescription}
              </div>
            </div>
            <div className="flex flex-row  items-center gap-2">
              <div className="w-6 h-6 aspect-square bg-red-600 rounded-lg" />
              <div className="text-xs w-full text-left text-color-text-tertiary">
                {rightDescription}
              </div>
            </div>
          </div>
        </div>
        {/* <PoliticsScale proportion={0.9} /> */}
      </RaindropCard>
    </div>
  );
};

const PoliticalGraphElement = () => {
  const PoliticalGraphDot = ({ translateString, isSelected = false }) => {
    let tailwindSize = "w-2 h-2";
    let tailwindOpacity = "opacity-80";

    if (isSelected) {
      tailwindSize = "w-4 h-4";
      tailwindOpacity = "";
    }

    return (
      <div
        className={`${tailwindSize} ${tailwindOpacity} rounded-full bg-white absolute  cursor-pointer hover:scale-95 active:scale-90 transition-all`}
        style={{
          translate: translateString,
        }}
      />
    );
  };
  const tailwindBackground = "bg-gradient-to-br from-blue-500  to-red-500";
  return (
    <div
      className={`flex items-center justify-center w-[300px] h-[300px] aspect-square rounded-lg border-4 border-white relative  ${tailwindBackground} `}
    >
      <div className="flex flex-col items-center justify-center h-full w-full absolute p-2 ">
        <div className="flex flex-row items-center absolute w-full px-2 gap-2 opacity-20">
          <i className="fas fa-hand-holding-heart text-xs" />
          <div className="w-[90%] h-[2px] bg-white  rounded-full" />
          <i className="fas fa-coins text-xs" />
        </div>

        <div className="flex flex-col items-center absolute  h-full  py-2 gap-2 opacity-20">
          <i className="fas fa-heart text-xs" />
          <div className="w-[2px] h-[90%] bg-white rounded-full" />
          <i className="fas fa-shield text-xs" />
        </div>
      </div>

      <PoliticalGraphDot translateString="-90px -90px" isSelected={true} />
      <PoliticalGraphDot translateString="50px 90px" />
      <PoliticalGraphDot translateString="20px -70px" />
      <PoliticalGraphDot translateString="-90px 50px" />
      <PoliticalGraphDot translateString="-20px -50px" />
    </div>
  );
};

const PoliticalChartKey = ({ doShowKey = true }) => {
  if (!doShowKey) {
    return null;
  }
  const RaindropTextLabel = ({ text, icon, tailwindIconColor }) => {
    return (
      <div className="flex flex-row gap-4 items-center w-full text-left  text-color-dark-text-secondary">
        <i className={`fas ${icon} text-lg ${tailwindIconColor}`} />
        <p>{text}</p>
      </div>
    );
  };
  return (
    <div className="flex flex-col gap-5 w-full max-w-[300px]">
      <RaindropTextLabel
        text={
          "Likely to supports human freedoms in marriage and bodily autonomy"
        }
        icon="fa-heart"
        tailwindIconColor={"text-blue-300"}
      />
      <div className="w-1 rounded-full h-10 ml-2 bg-slate-600" />
      <RaindropTextLabel
        text={"Likely supports traditional family values"}
        icon="fa-shield"
        tailwindIconColor={"text-red-300"}
      />
      <RaindropTextLabel
        text={
          "Likely supports government regulation and tax-payer support for people in need"
        }
        icon="fa-hand-holding-heart"
        tailwindIconColor={"text-blue-300"}
      />
      <div className="w-1 rounded-full h-10 ml-2 bg-slate-600" />

      <RaindropTextLabel
        text={
          "Likely supports lower taxes for companies and wealthy individuals"
        }
        icon="fa-coins"
        tailwindIconColor={"text-red-300"}
      />
    </div>
  );
};

const PoliticalChart = ({
  isPolitical = false,
  doShowKey = false,
  setCurrentModalComponent = (x) => {},
}) => {
  if (!isPolitical) {
    return false;
  }

  return (
    <div className="flex flex-col gap-4 w-full items-center justify-center">
      <PoliticalGraphElement />
      <PoliticalChartKey doShowKey={doShowKey} />
      <RaindropButton
        title="What is this?"
        size={Size.Large}
        icon="fa-info-circle"
        onClick={() => {
          setCurrentModalComponent(<PoliticalChartKey />);
        }}
      />
    </div>
  );
};

export default PoliticalChart;
